import translations from './i18n';
const ext = {
  th: {
    mr_example: 'ไทย',
    rg_phone_sub_nootp: 'กรอกเบอร์โทรศัพท์เพื่อใช้สมัครสมาชิก',
    // ── ฝาก 3 ช่องทาง (v3) ──
    ap_ch_auto: 'ออโต้',
    ap_ch_bank: 'สลิป',
    ap_ch_true: 'ซองทรู',
    ap_slip_upload_label: 'อัปโหลดสลิปการโอน',
    ap_slip_choose: 'แตะเพื่อเลือกรูปสลิป',
    ap_slip_uploading: 'กำลังอัปโหลด...',
    ap_slip_confirm: 'ยืนยันการโอน / ส่งสลิป',
    ap_slip_upload_success: 'ส่งสลิปสำเร็จ ระบบกำลังตรวจสอบ',
    ap_slip_upload_failed: 'อัปโหลดสลิปไม่สำเร็จ กรุณาลองใหม่',
    ap_slip_select_first: 'กรุณาเลือกรูปสลิปก่อน',
    ap_true_gift_title: 'เติมผ่านซองทรูมันนี่',
    ap_true_gift_hint: 'วางลิงก์ซองของขวัญ TrueMoney เพื่อเติมเงินอัตโนมัติ',
    ap_true_submit: 'ยืนยันเติมเงิน',
    ap_processing: 'กำลังดำเนินการ...',
    ap_true_fill_all: 'กรุณากรอกข้อมูลให้ครบ',
    ap_true_submit_success: 'ส่งรายการสำเร็จ',
    ap_true_submit_failed: 'ทำรายการไม่สำเร็จ',
    ap_true_amount_ph: 'จำนวนเงิน',
    ap_true_phone_ph: 'เบอร์ทรูมันนี่',
    ap_ch_truewallet: 'วอลเล็ท',
    ap_ch_crypto: 'คริปโต',
    ap_true_dest: 'เบอร์ปลายทาง',
    crypto_thb_label: 'จำนวนเงิน (บาท)',
    crypto_wallet_address: 'ที่อยู่กระเป๋า (Wallet Address)',
    crypto_send_warn_prefix: 'โอนเฉพาะ',
    crypto_send_warn_suffix: 'เท่านั้น ผิดเครือข่ายเงินหาย',
    strategy_title: 'สูตรเกม',
    strategy_subtitle: 'เทคนิคและสูตรเล่นเกมยอดนิยม',
    strategy_prefix: 'สูตร',
    strategy_note: '* สูตรเป็นเพียงแนวทางช่วยวางแผน ไม่การันตีผลชนะ โปรดเล่นอย่างมีสติและกำหนดงบประมาณ',
    event_title: 'กิจกรรม',
    event_hero_title: 'กิจกรรมภายในเครือเว็บ',
    event_hero_sub: 'ร่วมสนุกลุ้นรางวัลและสิทธิพิเศษมากมาย',
    rank_tab_win: 'ชนะสูงสุด',
    rank_tab_credit: 'เงินได้สูงสุด',
    rank_round_current: 'ผลรอบปัจจุบัน',
    rank_winamount: 'ยอดชนะ',
    rank_prize: 'รางวัล',
    wd_to_account: 'เงินจะโอนเข้าบัญชีนี้',
    ap_menu_social: 'โซเชียล',
    // register.js
    mr_topup_min: 'เติมขั้นต่ำ',
    mr_baht_max: 'บาท สูงสุด',
    mr_phone_wrong: 'คุณใส่เบอร์ผิดพลาด',
    mr_phone_taken: 'เบอร์นี้มีคนใช้แล้ว',
    mr_too_frequent: 'คุณทำรายการถี่เกินไป โปรดรอซักครู่',
    mr_pass_mismatch: 'คุณไส่พาสเวิดไม่ตรงกัน',
    mr_pass_empty: 'คุณไม่ใส่พาสเวิด',
    mr_pass_too_short: 'ใส่พาสเวิดน้อยกว่า 6 ตัว ',
    mr_select_bank: 'กรุณาเลือกธนาคาร หรือใส่ข้อมูลให้ครบถ้วน',
    mr_number_incomplete: 'คุณใส่ตัวเลขไม่ครบ',
    mr_code_wrong: 'รหัสผิดพลาด',
    mr_no_account_number: 'คุณไม่ทำการใส่เลขบัญชีธนาคาร',
    mr_check_account_again: 'โปรดตรวจสอบเลขบัญชีอีกครั้ง',
    mr_no_bank_selected: 'คุณยังไม่ได้เลือกธนาคาร',
    mr_account_invalid: 'เลขบัญชีไม่ถูกต้อง',
    mr_no_name: 'คุณไม่ทำการใส่ ชื่อ-นามสกุล',
    mr_pass_max15: 'พาสเวิดสูงสุดไม่เกิน 15 ตัว',
    mr_pass_min15: 'พาสเวิดต่ำไม่เกิน 15 ตัว',
    mr_confirm_mismatch: 'รหัสยิืนยันไม่ตรงกัน',
    mr_register_done: 'ทำการสมัครเรียบร้อย กรุณารอซักครู่',
    mr_account_registered: 'เลขบัญชี นี้ทำการสมัครไปแล้ว',
    mr_username_registered: 'Username นี้ทำการสมัครไปแล้ว',
    mr_username_invalid: 'Username หรือ ชื่อในการสมัครไม่ถูกต้อง',
    // navmenu.js
    mr_arcade: 'อาร์เคด',
    mr_freegame: 'ฟรีเกม',
    // main.js (cashback line)
    mr_cashback_got: 'คุณได้รับเครดิตยอดเสีย',
    mr_cashback_calc: 'บาท (คำนวณทุกวันอาทิตย์ เวลา 00.00น.)',
    // luckyfortune.js / spinweel.js
    mr_wheel_fun: 'กงล้อมหาสนุก',
    mr_wheel_topup_cond: 'เติม 500 ได้สิทธิ์หมุนฟรี 1 สิทธิ์',
    mr_spin: 'หมุน',
    // paoyingchub.js
    mr_not_login: 'คุณไม่ได้ Login !!',
    mr_select_option: 'โปรดเลือก ตัวเลือก !!',
    mr_select_bet: 'โปรดเลือก เงินเดิมพัน !!',
    mr_confirm_create_room: 'ยืนยันการสร้างห้อง',
    mr_room_created: 'สร้างห้องเรียบร้อยแล้ว',
    mr_not_enough_create: 'แต้มไม่พอจะสร้างห้อง',
    mr_confirm_play: 'ยืนยันการเล่น',
    mr_not_enough: 'แต้มไม่พอ !!',
    mr_paper: 'กระดาษ',
    mr_rock: 'ค้อน',
    mr_scissors: 'กรรไกร',
    mr_random: 'แบบสุ่ม',
    mr_your_bet_is: 'จำนวนเดิมพันของคุณคือ',
    mr_points_option_is: 'คะแนน ตัวเลือกคือ',
    mr_room_bet_is: 'ห้องนี้แต้มดิมพันคือ',
    mr_win_game_points: 'คุณชนะเกมส์นี้ คะแนนที่ได้รับคือ',
    mr_draw_game_points: 'คุณเสมอเกมส์นี้ คะแนนที่ได้รับคือ',
    mr_points_excl: 'คะแนน !!',
    mr_lose_game: 'คุณแพ้เกมส์นี้ !!',
    mr_win: 'ชนะ',
    mr_lose: 'แพ้',
    mr_draw: 'เสมอ',
    mr_paoyingchub: 'เป่ายิงฉุบ',
    mr_play_game: 'เล่นเกมส์',
    mr_win_lose_result: 'ผลแพ้ชนะ',
    mr_bet_amount: 'จำนวนที่เดิมพัน',
    mr_your_option: 'ตัวเลือกของท่าน',
    mr_hr: 'น.',
  },
  en: {
    mr_example: 'English',
    rg_phone_sub_nootp: 'Enter your phone number to register',
    ap_ch_auto: 'Auto',
    ap_ch_bank: 'Transfer + Slip',
    ap_ch_true: 'TrueMoney',
    ap_slip_upload_label: 'Upload transfer slip',
    ap_slip_choose: 'Tap to select slip image',
    ap_slip_uploading: 'Uploading...',
    ap_slip_confirm: 'Confirm transfer / send slip',
    ap_slip_upload_success: 'Slip submitted, system is verifying',
    ap_slip_upload_failed: 'Slip upload failed, please try again',
    ap_slip_select_first: 'Please select a slip image first',
    ap_true_gift_title: 'Top up via TrueMoney gift',
    ap_true_gift_hint: 'Paste a TrueMoney gift link to top up automatically',
    ap_true_submit: 'Confirm top-up',
    ap_processing: 'Processing...',
    ap_true_fill_all: 'Please fill in all fields',
    ap_true_submit_success: 'Submitted successfully',
    ap_true_submit_failed: 'Transaction failed',
    ap_true_amount_ph: 'Amount',
    ap_true_phone_ph: 'TrueMoney phone',
    ap_ch_truewallet: 'TrueWallet',
    ap_ch_crypto: 'Crypto',
    ap_true_dest: 'Destination number',
    crypto_thb_label: 'Amount (THB)',
    crypto_wallet_address: 'Wallet Address',
    crypto_send_warn_prefix: 'Send only',
    crypto_send_warn_suffix: 'wrong network = funds lost',
    strategy_title: 'Strategy',
    strategy_subtitle: 'Tips & strategies for popular games',
    strategy_prefix: 'Strategy:',
    strategy_note: '* Strategies are guidance only and do not guarantee wins. Play responsibly and set a budget.',
    event_title: 'Events',
    event_hero_title: 'Network Events',
    event_hero_sub: 'Join the fun for prizes and special rewards',
    rank_tab_win: 'Top Wins',
    rank_tab_credit: 'Top Credits',
    rank_round_current: 'Current Round',
    rank_winamount: 'Win Amount',
    rank_prize: 'Prize',
    wd_to_account: 'Funds will be sent to this account',
    ap_menu_social: 'Social',
    mr_topup_min: 'Minimum top-up',
    mr_baht_max: 'baht, maximum',
    mr_phone_wrong: 'You entered an invalid phone number',
    mr_phone_taken: 'This phone number is already in use',
    mr_too_frequent: 'You are making requests too frequently. Please wait a moment',
    mr_pass_mismatch: 'Your passwords do not match',
    mr_pass_empty: 'You did not enter a password',
    mr_pass_too_short: 'Password is less than 6 characters ',
    mr_select_bank: 'Please select a bank or fill in all the information',
    mr_number_incomplete: 'You did not enter the complete number',
    mr_code_wrong: 'Invalid code',
    mr_no_account_number: 'You did not enter a bank account number',
    mr_check_account_again: 'Please check the account number again',
    mr_no_bank_selected: 'You have not selected a bank yet',
    mr_account_invalid: 'Invalid account number',
    mr_no_name: 'You did not enter your first and last name',
    mr_pass_max15: 'Password must not exceed 15 characters',
    mr_pass_min15: 'Password must not exceed 15 characters',
    mr_confirm_mismatch: 'Confirmation code does not match',
    mr_register_done: 'Registration complete, please wait a moment',
    mr_account_registered: 'This account number has already been registered',
    mr_username_registered: 'This Username has already been registered',
    mr_username_invalid: 'Username or registration name is invalid',
    mr_arcade: 'Arcade',
    mr_freegame: 'Free Game',
    mr_cashback_got: 'You received cashback credit of',
    mr_cashback_calc: 'baht (calculated every Sunday at 00:00)',
    mr_wheel_fun: 'Wheel of Fun',
    mr_wheel_topup_cond: 'Top up 500 to get 1 free spin',
    mr_spin: 'Spin',
    mr_not_login: 'You are not logged in !!',
    mr_select_option: 'Please select an option !!',
    mr_select_bet: 'Please select a bet amount !!',
    mr_confirm_create_room: 'Confirm room creation',
    mr_room_created: 'Room created successfully',
    mr_not_enough_create: 'Not enough points to create a room',
    mr_confirm_play: 'Confirm play',
    mr_not_enough: 'Not enough points !!',
    mr_paper: 'Paper',
    mr_rock: 'Rock',
    mr_scissors: 'Scissors',
    mr_random: 'Random',
    mr_your_bet_is: 'Your bet amount is',
    mr_points_option_is: 'points, your option is',
    mr_room_bet_is: 'This room bet is',
    mr_win_game_points: 'You won this game, points received:',
    mr_draw_game_points: 'You drew this game, points received:',
    mr_points_excl: 'points !!',
    mr_lose_game: 'You lost this game !!',
    mr_win: 'Win',
    mr_lose: 'Lose',
    mr_draw: 'Draw',
    mr_paoyingchub: 'Rock Paper Scissors',
    mr_play_game: 'Play Game',
    mr_win_lose_result: 'Results',
    mr_bet_amount: 'Bet Amount',
    mr_your_option: 'Your Option',
    mr_hr: 'hrs',
  },
  zh: {
    mr_example: '中文',
    rg_phone_sub_nootp: '输入手机号码进行注册',
    ap_ch_auto: '自动充值',
    ap_ch_bank: '转账 + 凭证',
    ap_ch_true: 'TrueMoney',
    ap_slip_upload_label: '上传转账凭证',
    ap_slip_choose: '点击选择凭证图片',
    ap_slip_uploading: '上传中...',
    ap_slip_confirm: '确认转账 / 提交凭证',
    ap_slip_upload_success: '凭证已提交，系统正在核实',
    ap_slip_upload_failed: '凭证上传失败，请重试',
    ap_slip_select_first: '请先选择凭证图片',
    ap_true_gift_title: '通过 TrueMoney 礼包充值',
    ap_true_gift_hint: '粘贴 TrueMoney 礼包链接即可自动充值',
    ap_true_submit: '确认充值',
    ap_processing: '处理中...',
    ap_true_fill_all: '请填写完整信息',
    ap_true_submit_success: '提交成功',
    ap_true_submit_failed: '操作失败',
    ap_true_amount_ph: '金额',
    ap_true_phone_ph: 'TrueMoney 手机号',
    ap_ch_truewallet: 'TrueWallet',
    ap_ch_crypto: '加密货币',
    ap_true_dest: '目标号码',
    crypto_thb_label: '金额（泰铢）',
    crypto_wallet_address: '钱包地址',
    crypto_send_warn_prefix: '仅转入',
    crypto_send_warn_suffix: '错误网络将丢失资金',
    strategy_title: '游戏攻略',
    strategy_subtitle: '热门游戏技巧与攻略',
    strategy_prefix: '攻略',
    strategy_note: '* 攻略仅供参考，不保证获胜。请理性游戏并设定预算。',
    event_title: '活动',
    event_hero_title: '全网活动',
    event_hero_sub: '参与活动赢取丰厚奖励与特权',
    rank_tab_win: '最高胜额',
    rank_tab_credit: '最高盈利',
    rank_round_current: '本轮结果',
    rank_winamount: '胜额',
    rank_prize: '奖励',
    wd_to_account: '资金将转入此账户',
    ap_menu_social: '社交',
    mr_topup_min: '最低充值',
    mr_baht_max: '泰铢，最高',
    mr_phone_wrong: '您输入的手机号码有误',
    mr_phone_taken: '该手机号码已被使用',
    mr_too_frequent: '您的操作过于频繁，请稍候',
    mr_pass_mismatch: '您输入的密码不一致',
    mr_pass_empty: '您没有输入密码',
    mr_pass_too_short: '密码少于6个字符 ',
    mr_select_bank: '请选择银行或填写完整信息',
    mr_number_incomplete: '您输入的数字不完整',
    mr_code_wrong: '验证码错误',
    mr_no_account_number: '您没有输入银行账号',
    mr_check_account_again: '请再次核对账号',
    mr_no_bank_selected: '您还没有选择银行',
    mr_account_invalid: '账号无效',
    mr_no_name: '您没有输入姓名',
    mr_pass_max15: '密码不得超过15个字符',
    mr_pass_min15: '密码不得超过15个字符',
    mr_confirm_mismatch: '确认码不匹配',
    mr_register_done: '注册完成，请稍候',
    mr_account_registered: '该账号已注册',
    mr_username_registered: '该用户名已注册',
    mr_username_invalid: '用户名或注册姓名无效',
    mr_arcade: '街机',
    mr_freegame: '免费游戏',
    mr_cashback_got: '您获得的亏损返现额度为',
    mr_cashback_calc: '泰铢（每周日00:00计算）',
    mr_wheel_fun: '欢乐转盘',
    mr_wheel_topup_cond: '充值500可获得1次免费旋转机会',
    mr_spin: '旋转',
    mr_not_login: '您尚未登录 !!',
    mr_select_option: '请选择一个选项 !!',
    mr_select_bet: '请选择投注金额 !!',
    mr_confirm_create_room: '确认创建房间',
    mr_room_created: '房间创建成功',
    mr_not_enough_create: '积分不足，无法创建房间',
    mr_confirm_play: '确认游戏',
    mr_not_enough: '积分不足 !!',
    mr_paper: '布',
    mr_rock: '石头',
    mr_scissors: '剪刀',
    mr_random: '随机',
    mr_your_bet_is: '您的投注金额为',
    mr_points_option_is: '分，您的选择是',
    mr_room_bet_is: '该房间投注为',
    mr_win_game_points: '您赢得本局，获得积分：',
    mr_draw_game_points: '本局平局，获得积分：',
    mr_points_excl: '分 !!',
    mr_lose_game: '您输掉了本局 !!',
    mr_win: '赢',
    mr_lose: '输',
    mr_draw: '平局',
    mr_paoyingchub: '剪刀石头布',
    mr_play_game: '开始游戏',
    mr_win_lose_result: '比赛结果',
    mr_bet_amount: '投注金额',
    mr_your_option: '您的选择',
    mr_hr: '时',
  },
  ja: {
    mr_example: '日本語',
    rg_phone_sub_nootp: '電話番号を入力して登録',
    ap_ch_auto: 'オート入金',
    ap_ch_bank: '振込 + 明細',
    ap_ch_true: 'TrueMoney',
    ap_slip_upload_label: '振込明細をアップロード',
    ap_slip_choose: 'タップして明細画像を選択',
    ap_slip_uploading: 'アップロード中...',
    ap_slip_confirm: '振込を確認 / 明細を送信',
    ap_slip_upload_success: '明細を送信しました。確認中です',
    ap_slip_upload_failed: '明細のアップロードに失敗しました。再試行してください',
    ap_slip_select_first: '先に明細画像を選択してください',
    ap_true_gift_title: 'TrueMoneyギフトで入金',
    ap_true_gift_hint: 'TrueMoneyギフトリンクを貼り付けて自動入金',
    ap_true_submit: '入金を確認',
    ap_processing: '処理中...',
    ap_true_fill_all: 'すべての項目を入力してください',
    ap_true_submit_success: '送信に成功しました',
    ap_true_submit_failed: '取引に失敗しました',
    ap_true_amount_ph: '金額',
    ap_true_phone_ph: 'TrueMoney 電話番号',
    ap_ch_truewallet: 'TrueWallet',
    ap_ch_crypto: '暗号資産',
    ap_true_dest: '送金先番号',
    crypto_thb_label: '金額（バーツ）',
    crypto_wallet_address: 'ウォレットアドレス',
    crypto_send_warn_prefix: '送金は',
    crypto_send_warn_suffix: 'のみ、ネットワークを間違えると資金は失われます',
    strategy_title: '攻略',
    strategy_subtitle: '人気ゲームのコツと攻略',
    strategy_prefix: '攻略：',
    strategy_note: '* 攻略は参考情報であり勝利を保証しません。責任を持って予算を設定してプレイしてください。',
    event_title: 'イベント',
    event_hero_title: 'ネットワークイベント',
    event_hero_sub: '豪華賞品と特典が当たるイベントに参加',
    rank_tab_win: '勝利額トップ',
    rank_tab_credit: '獲得額トップ',
    rank_round_current: '今回の結果',
    rank_winamount: '勝利額',
    rank_prize: '賞金',
    wd_to_account: '資金はこの口座に振り込まれます',
    ap_menu_social: 'ソーシャル',
    mr_topup_min: '最低入金',
    mr_baht_max: 'バーツ、最高',
    mr_phone_wrong: '電話番号が正しくありません',
    mr_phone_taken: 'この電話番号はすでに使用されています',
    mr_too_frequent: '操作が頻繁すぎます。しばらくお待ちください',
    mr_pass_mismatch: 'パスワードが一致しません',
    mr_pass_empty: 'パスワードが入力されていません',
    mr_pass_too_short: 'パスワードが6文字未満です ',
    mr_select_bank: '銀行を選択するか、情報をすべて入力してください',
    mr_number_incomplete: '数字が不完全です',
    mr_code_wrong: 'コードが正しくありません',
    mr_no_account_number: '銀行口座番号が入力されていません',
    mr_check_account_again: '口座番号をもう一度確認してください',
    mr_no_bank_selected: 'まだ銀行が選択されていません',
    mr_account_invalid: '口座番号が無効です',
    mr_no_name: '氏名が入力されていません',
    mr_pass_max15: 'パスワードは15文字以内にしてください',
    mr_pass_min15: 'パスワードは15文字以内にしてください',
    mr_confirm_mismatch: '確認コードが一致しません',
    mr_register_done: '登録が完了しました。しばらくお待ちください',
    mr_account_registered: 'この口座番号はすでに登録されています',
    mr_username_registered: 'このユーザー名はすでに登録されています',
    mr_username_invalid: 'ユーザー名または登録名が無効です',
    mr_arcade: 'アーケード',
    mr_freegame: 'フリーゲーム',
    mr_cashback_got: '受け取ったキャッシュバッククレジットは',
    mr_cashback_calc: 'バーツ（毎週日曜00:00に計算）',
    mr_wheel_fun: 'ワクワクルーレット',
    mr_wheel_topup_cond: '500入金で無料スピン1回獲得',
    mr_spin: 'スピン',
    mr_not_login: 'ログインしていません !!',
    mr_select_option: '選択肢を選んでください !!',
    mr_select_bet: 'ベット額を選んでください !!',
    mr_confirm_create_room: 'ルーム作成の確認',
    mr_room_created: 'ルームが正常に作成されました',
    mr_not_enough_create: 'ポイントが足りずルームを作成できません',
    mr_confirm_play: 'プレイの確認',
    mr_not_enough: 'ポイントが足りません !!',
    mr_paper: 'パー',
    mr_rock: 'グー',
    mr_scissors: 'チョキ',
    mr_random: 'ランダム',
    mr_your_bet_is: 'あなたのベット額は',
    mr_points_option_is: 'ポイント、選択肢は',
    mr_room_bet_is: 'このルームのベットは',
    mr_win_game_points: 'このゲームに勝ちました。獲得ポイント：',
    mr_draw_game_points: 'このゲームは引き分けです。獲得ポイント：',
    mr_points_excl: 'ポイント !!',
    mr_lose_game: 'このゲームに負けました !!',
    mr_win: '勝ち',
    mr_lose: '負け',
    mr_draw: '引き分け',
    mr_paoyingchub: 'じゃんけん',
    mr_play_game: 'ゲームをプレイ',
    mr_win_lose_result: '勝敗結果',
    mr_bet_amount: 'ベット額',
    mr_your_option: 'あなたの選択',
    mr_hr: '時',
  },
  my: {
    mr_example: 'မြန်မာ',
    rg_phone_sub_nootp: 'စာရင်းသွင်းရန် ဖုန်းနံပါတ်ထည့်ပါ',
    ap_ch_auto: 'အော်တိုသွင်း',
    ap_ch_bank: 'လွှဲ + ဘောက်ချာ',
    ap_ch_true: 'TrueMoney',
    ap_slip_upload_label: 'လွှဲပြောင်းဘောက်ချာ တင်ပါ',
    ap_slip_choose: 'ဘောက်ချာပုံ ရွေးရန် နှိပ်ပါ',
    ap_slip_uploading: 'တင်နေသည်...',
    ap_slip_confirm: 'လွှဲမှု အတည်ပြု / ဘောက်ချာ ပို့ပါ',
    ap_slip_upload_success: 'ဘောက်ချာ ပို့ပြီးပါပြီ၊ စစ်ဆေးနေသည်',
    ap_slip_upload_failed: 'ဘောက်ချာ တင်၍မရပါ၊ ထပ်စမ်းပါ',
    ap_slip_select_first: 'ဘောက်ချာပုံ အရင်ရွေးပါ',
    ap_true_gift_title: 'TrueMoney လက်ဆောင်ဖြင့် ဖြည့်ပါ',
    ap_true_gift_hint: 'အလိုအလျောက်ဖြည့်ရန် TrueMoney လက်ဆောင်လင့်ခ်ကို ကူးထည့်ပါ',
    ap_true_submit: 'ဖြည့်သွင်းမှု အတည်ပြုပါ',
    ap_processing: 'ဆောင်ရွက်နေသည်...',
    ap_true_fill_all: 'အချက်အလက်အားလုံး ဖြည့်ပါ',
    ap_true_submit_success: 'ပို့ဆောင်ပြီးပါပြီ',
    ap_true_submit_failed: 'လုပ်ဆောင်မှု မအောင်မြင်ပါ',
    ap_true_amount_ph: 'ပမာဏ',
    ap_true_phone_ph: 'TrueMoney ဖုန်းနံပါတ်',
    ap_ch_truewallet: 'TrueWallet',
    ap_ch_crypto: 'ခရစ်ပ်တို',
    ap_true_dest: 'လက်ခံဖုန်းနံပါတ်',
    crypto_thb_label: 'ပမာဏ (ဘတ်)',
    crypto_wallet_address: 'Wallet လိပ်စာ',
    crypto_send_warn_prefix: 'ပို့ရန်',
    crypto_send_warn_suffix: 'သာ၊ ကွန်ရက်မှားလျှင် ငွေဆုံးမည်',
    strategy_title: 'ဂိမ်းနည်းဗျူဟာ',
    strategy_subtitle: 'ရေပန်းစားဂိမ်းများအတွက် နည်းလမ်းများ',
    strategy_prefix: 'နည်းဗျူဟာ',
    strategy_note: '* နည်းဗျူဟာများသည် လမ်းညွှန်မှုသာဖြစ်ပြီး အနိုင်ရရှိမှုကို အာမမခံပါ။ တာဝန်သိစွာ ဘတ်ဂျက်သတ်မှတ်၍ ကစားပါ။',
    event_title: 'ပွဲများ',
    event_hero_title: 'ကွန်ရက်တွင်းပွဲများ',
    event_hero_sub: 'ဆုလက်ဆောင်နှင့် အထူးအခွင့်အရေးများအတွက် ပါဝင်ပါ',
    rank_tab_win: 'အနိုင်အများဆုံး',
    rank_tab_credit: 'ဝင်ငွေအများဆုံး',
    rank_round_current: 'လက်ရှိအround',
    rank_winamount: 'အနိုင်ပမာဏ',
    rank_prize: 'ဆုလက်ဆောင်',
    wd_to_account: 'ငွေကို ဤအကောင့်သို့ လွှဲပေးမည်',
    ap_menu_social: 'လူမှုကွန်ရက်',
    mr_topup_min: 'အနည်းဆုံးဖြည့်သွင်းမှု',
    mr_baht_max: 'ဘတ်၊ အများဆုံး',
    mr_phone_wrong: 'ဖုန်းနံပါတ် မှားယွင်းနေပါသည်',
    mr_phone_taken: 'ဤဖုန်းနံပါတ်ကို အသုံးပြုပြီးဖြစ်သည်',
    mr_too_frequent: 'အလွန်မကြာခဏ ပြုလုပ်နေပါသည်။ ခဏစောင့်ပါ',
    mr_pass_mismatch: 'စကားဝှက် မကိုက်ညီပါ',
    mr_pass_empty: 'စကားဝှက် ထည့်မထားပါ',
    mr_pass_too_short: 'စကားဝှက် ၆ လုံးထက်နည်းနေသည် ',
    mr_select_bank: 'ဘဏ်ရွေးပါ သို့မဟုတ် အချက်အလက်အပြည့်အစုံ ဖြည့်ပါ',
    mr_number_incomplete: 'ဂဏန်းမပြည့်စုံပါ',
    mr_code_wrong: 'ကုဒ်မှားနေသည်',
    mr_no_account_number: 'ဘဏ်အကောင့်နံပါတ် ထည့်မထားပါ',
    mr_check_account_again: 'အကောင့်နံပါတ်ကို ထပ်စစ်ပါ',
    mr_no_bank_selected: 'ဘဏ်မရွေးရသေးပါ',
    mr_account_invalid: 'အကောင့်နံပါတ် မမှန်ကန်ပါ',
    mr_no_name: 'အမည်နှင့် မျိုးနွယ်အမည် ထည့်မထားပါ',
    mr_pass_max15: 'စကားဝှက်သည် ၁၅ လုံးထက် မပိုရပါ',
    mr_pass_min15: 'စကားဝှက်သည် ၁၅ လုံးထက် မပိုရပါ',
    mr_confirm_mismatch: 'အတည်ပြုကုဒ် မကိုက်ညီပါ',
    mr_register_done: 'စာရင်းသွင်းပြီးပါပြီ၊ ခဏစောင့်ပါ',
    mr_account_registered: 'ဤအကောင့်နံပါတ်ကို စာရင်းသွင်းပြီးဖြစ်သည်',
    mr_username_registered: 'ဤအသုံးပြုသူအမည်ကို စာရင်းသွင်းပြီးဖြစ်သည်',
    mr_username_invalid: 'အသုံးပြုသူအမည် သို့မဟုတ် စာရင်းသွင်းအမည် မမှန်ကန်ပါ',
    mr_arcade: 'အာကိတ်',
    mr_freegame: 'အခမဲ့ဂိမ်း',
    mr_cashback_got: 'သင်ရရှိသော ရှုံးငွေပြန်အမ်းခရက်ဒစ်မှာ',
    mr_cashback_calc: 'ဘတ် (တနင်္ဂနွေတိုင်း 00:00 တွင် တွက်ချက်သည်)',
    mr_wheel_fun: 'ပျော်စရာဘီး',
    mr_wheel_topup_cond: '၅၀၀ ဖြည့်ပါက အခမဲ့လှည့်ခွင့် ၁ ကြိမ်ရမည်',
    mr_spin: 'လှည့်ပါ',
    mr_not_login: 'သင် Login မဝင်ရသေးပါ !!',
    mr_select_option: 'ရွေးချယ်စရာ တစ်ခုရွေးပါ !!',
    mr_select_bet: 'လောင်းကြေးပမာဏ ရွေးပါ !!',
    mr_confirm_create_room: 'အခန်းဖန်တီးခြင်း အတည်ပြုပါ',
    mr_room_created: 'အခန်းဖန်တီးပြီးပါပြီ',
    mr_not_enough_create: 'အခန်းဖန်တီးရန် အမှတ်မလုံလောက်ပါ',
    mr_confirm_play: 'ကစားခြင်း အတည်ပြုပါ',
    mr_not_enough: 'အမှတ်မလုံလောက်ပါ !!',
    mr_paper: 'စက္ကူ',
    mr_rock: 'ကျောက်',
    mr_scissors: 'ကတ်ကြေး',
    mr_random: 'ကျပန်း',
    mr_your_bet_is: 'သင့်လောင်းကြေးပမာဏမှာ',
    mr_points_option_is: 'အမှတ်၊ ရွေးချယ်မှုမှာ',
    mr_room_bet_is: 'ဤအခန်း၏လောင်းကြေးမှာ',
    mr_win_game_points: 'ဤဂိမ်းတွင် သင်နိုင်ပါသည်၊ ရရှိသောအမှတ်မှာ',
    mr_draw_game_points: 'ဤဂိမ်းသရေဖြစ်သည်၊ ရရှိသောအမှတ်မှာ',
    mr_points_excl: 'အမှတ် !!',
    mr_lose_game: 'ဤဂိမ်းတွင် သင်ရှုံးပါသည် !!',
    mr_win: 'နိုင်',
    mr_lose: 'ရှုံး',
    mr_draw: 'သရေ',
    mr_paoyingchub: 'ကတ်ကြေး ကျောက် စက္ကူ',
    mr_play_game: 'ဂိမ်းကစားရန်',
    mr_win_lose_result: 'ရလဒ်',
    mr_bet_amount: 'လောင်းကြေးပမာဏ',
    mr_your_option: 'သင့်ရွေးချယ်မှု',
    mr_hr: 'နာရီ',
  },
  lo: {
    mr_example: 'ລາວ',
    rg_phone_sub_nootp: 'ປ້ອນເບີໂທເພື່ອສະໝັກສະมาชิກ',
    ap_ch_auto: 'ຝາກອັດຕະໂນมัด',
    ap_ch_bank: 'ໂອນ + ສລິບ',
    ap_ch_true: 'ทรูมันนี่',
    ap_slip_upload_label: 'ອັບໂหลดສລິບການໂອນ',
    ap_slip_choose: 'ແຕะເພื່ອເລືອกຮูปສລິບ',
    ap_slip_uploading: 'ກຳลັงอัปໂหลด...',
    ap_slip_confirm: 'ຢืนยันການໂອນ / ສ່ງສລິບ',
    ap_slip_upload_success: 'ສ່ງສລິບສຳเร็ดแล้ว ระบบกำลังตรวจสอบ',
    ap_slip_upload_failed: 'ອັບໂหลดສລິບບໍ່ສຳเร็ด ກະລุนาลองใหม่',
    ap_slip_select_first: 'ກะລุนาเลือกຮูปສລິບก่อน',
    ap_true_gift_title: 'ເຕີມຜ່ານຊองทรูมันนี่',
    ap_true_gift_hint: 'ວາງลิงก์ຊองของขวัญ TrueMoney ເพื່ອເຕີມເງินอัตโนมัติ',
    ap_true_submit: 'ຢืนยันເຕີມເງิน',
    ap_processing: 'ກຳลังดำเนินการ...',
    ap_true_fill_all: 'ກะลุนากรอกข้อมูลให้ครบ',
    ap_true_submit_success: 'ສ່ງລາຍการສຳเร็ด',
    ap_true_submit_failed: 'ทำลາຍการบໍ່ສຳเร็ด',
    ap_true_amount_ph: 'ຈำนวนเงิน',
    ap_true_phone_ph: 'ເບີทรูมันนี่',
    ap_ch_truewallet: 'ทรูวอลเล็ท',
    ap_ch_crypto: 'ຄຣິບໂຕ',
    ap_true_dest: 'ເບີປາຍທາງ',
    crypto_thb_label: 'ຈำนวนเงิน (ບາດ)',
    crypto_wallet_address: 'ທີ່ຢູ່ກະເປົາ (Wallet Address)',
    crypto_send_warn_prefix: 'ໂອນສະເພາະ',
    crypto_send_warn_suffix: 'ເທົ່ານັ້ນ ຜິດເຄືອข่ายเงินหาย',
    strategy_title: 'ສູດເກມ',
    strategy_subtitle: 'ເຕັກນິກແລະສູດຫຼິ້ນເກมยอดนิยม',
    strategy_prefix: 'ສູດ',
    strategy_note: '* ສູດເປັນພຽງແນວທາງ ບໍ່ການັນຕີຜົນຊະນະ ກະລຸนาຫຼິ້ນຢ່າງມີສະຕິແລະກຳນົດງົບປະມານ',
    event_title: 'ກິດຈະກຳ',
    wd_to_account: 'ເງິນຈະໂອນເຂົ້າບັນຊີນີ້',
    ap_menu_social: 'ໂຊໂຊ',
    rank_tab_win: 'ຊະນະສູງສຸດ',
    rank_tab_credit: 'ເງິນໄດ້ສູງສຸດ',
    rank_round_current: 'ຜົນຮອບປັດຈຸບັນ',
    rank_winamount: 'ຍอດຊะນະ',
    rank_prize: 'ລາງວັນ',
    event_hero_title: 'ກິດຈະກຳພາຍໃນເຄືອເວັບ',
    event_hero_sub: 'ຮ່ວມສนุກลุ້ນລາງວັນແລະສິດທິພິເສດ',
    mr_topup_min: 'ເຕີມຂັ້ນຕ່ຳ',
    mr_baht_max: 'ບາດ ສູງສຸດ',
    mr_phone_wrong: 'ທ່ານໃສ່ເບີໂທຜິດ',
    mr_phone_taken: 'ເບີນີ້ມີຄົນໃຊ້ແລ້ວ',
    mr_too_frequent: 'ທ່ານເຮັດລາຍການຖີ່ເກີນໄປ ກະລຸນາລໍຖ້າ',
    mr_pass_mismatch: 'ລະຫັດຜ່ານຂອງທ່ານບໍ່ກົງກັນ',
    mr_pass_empty: 'ທ່ານບໍ່ໄດ້ໃສ່ລະຫັດຜ່ານ',
    mr_pass_too_short: 'ລະຫັດຜ່ານໜ້ອຍກວ່າ 6 ໂຕ ',
    mr_select_bank: 'ກະລຸນາເລືອກທະນາຄານ ຫຼື ໃສ່ຂໍ້ມູນໃຫ້ຄົບຖ້ວນ',
    mr_number_incomplete: 'ທ່ານໃສ່ຕົວເລກບໍ່ຄົບ',
    mr_code_wrong: 'ລະຫັດຜິດ',
    mr_no_account_number: 'ທ່ານບໍ່ໄດ້ໃສ່ເລກບັນຊີທະນາຄານ',
    mr_check_account_again: 'ກະລຸນາກວດສອບເລກບັນຊີອີກຄັ້ງ',
    mr_no_bank_selected: 'ທ່ານຍັງບໍ່ໄດ້ເລືອກທະນາຄານ',
    mr_account_invalid: 'ເລກບັນຊີບໍ່ຖືກຕ້ອງ',
    mr_no_name: 'ທ່ານບໍ່ໄດ້ໃສ່ ຊື່-ນາມສະກຸນ',
    mr_pass_max15: 'ລະຫັດຜ່ານສູງສຸດບໍ່ເກີນ 15 ໂຕ',
    mr_pass_min15: 'ລະຫັດຜ່ານສູງສຸດບໍ່ເກີນ 15 ໂຕ',
    mr_confirm_mismatch: 'ລະຫັດຢືນຢັນບໍ່ກົງກັນ',
    mr_register_done: 'ສະໝັກສຳເລັດແລ້ວ ກະລຸນາລໍຖ້າ',
    mr_account_registered: 'ເລກບັນຊີນີ້ໄດ້ສະໝັກໄປແລ້ວ',
    mr_username_registered: 'Username ນີ້ໄດ້ສະໝັກໄປແລ້ວ',
    mr_username_invalid: 'Username ຫຼື ຊື່ໃນການສະໝັກບໍ່ຖືກຕ້ອງ',
    mr_arcade: 'ອາເຄດ',
    mr_freegame: 'ເກມຟຣີ',
    mr_cashback_got: 'ທ່ານໄດ້ຮັບເຄຣດິດຍອດເສຍ',
    mr_cashback_calc: 'ບາດ (ຄຳນວນທຸກວັນອາທິດ ເວລາ 00:00)',
    mr_wheel_fun: 'ກົງລໍ້ມ່ວນຊື່ນ',
    mr_wheel_topup_cond: 'ເຕີມ 500 ໄດ້ສິດໝຸນຟຣີ 1 ສິດ',
    mr_spin: 'ໝຸນ',
    mr_not_login: 'ທ່ານຍັງບໍ່ໄດ້ Login !!',
    mr_select_option: 'ກະລຸນາເລືອກ ຕົວເລືອກ !!',
    mr_select_bet: 'ກະລຸນາເລືອກ ເງິນເດີມພັນ !!',
    mr_confirm_create_room: 'ຢືນຢັນການສ້າງຫ້ອງ',
    mr_room_created: 'ສ້າງຫ້ອງສຳເລັດແລ້ວ',
    mr_not_enough_create: 'ຄະແນນບໍ່ພໍຈະສ້າງຫ້ອງ',
    mr_confirm_play: 'ຢືນຢັນການຫຼິ້ນ',
    mr_not_enough: 'ຄະແນນບໍ່ພໍ !!',
    mr_paper: 'ເຈ້ຍ',
    mr_rock: 'ກ້ອນຫີນ',
    mr_scissors: 'ກັນໄກ',
    mr_random: 'ແບບສຸ່ມ',
    mr_your_bet_is: 'ຈຳນວນເດີມພັນຂອງທ່ານຄື',
    mr_points_option_is: 'ຄະແນນ ຕົວເລືອກຄື',
    mr_room_bet_is: 'ຫ້ອງນີ້ເດີມພັນຄື',
    mr_win_game_points: 'ທ່ານຊະນະເກມນີ້ ຄະແນນທີ່ໄດ້ຮັບຄື',
    mr_draw_game_points: 'ທ່ານເສີມເກມນີ້ ຄະແນນທີ່ໄດ້ຮັບຄື',
    mr_points_excl: 'ຄະແນນ !!',
    mr_lose_game: 'ທ່ານແພ້ເກມນີ້ !!',
    mr_win: 'ຊະນະ',
    mr_lose: 'ແພ້',
    mr_draw: 'ເສີມ',
    mr_paoyingchub: 'ເປົ້າຍິງສຸບ',
    mr_play_game: 'ຫຼິ້ນເກມ',
    mr_win_lose_result: 'ຜົນແພ້ຊະນະ',
    mr_bet_amount: 'ຈຳນວນທີ່ເດີມພັນ',
    mr_your_option: 'ຕົວເລືອກຂອງທ່ານ',
    mr_hr: 'ໂມງ',
  },
};
Object.keys(ext).forEach((l) => { translations[l] = Object.assign({}, translations[l], ext[l]); });
export default ext;
